export default __webpack_public_path__ + "static/media/website_logo.ad3f5e4c.png";